import {SetorDto} from "./setor-dto";
import {Role} from "../role";

export class UsuarioDto {
    id: number = -1;
    nome: string = "";
    nomeUsuario: string = "";
    primeiroNome: string = "";
    email: string = "";
    setor?: SetorDto = new SetorDto();
    permissoes?: Role[] =  new Array<Role>();
}